import { omit } from 'radash'
import type { UpdateStepPayloadSchema } from '@/schemas/step'
import type { PatchUpdateStepResponse } from '@/types/step'
import { httpClient } from '@/utils/http'

export const stepService = {
  update: (payload: UpdateStepPayloadSchema) =>
    httpClient
      .patch(`steps/${payload.id}`, { json: omit(payload, ['id']) })
      .json<PatchUpdateStepResponse>(),
}
